<template>
    <div>
        <Header />
        <div class="w-90 mt90">
            <h2>Terms and Conditions</h2>
            <br>
            <h5> Froot
            By using UniBud.com, you agree to abide by the following terms
            and conditions:<br><br>
            All text, graphics, and layouts on this website/app are copyrighted
            by UniBud. Access to this website/app does not confer on any user
            the right to UniBud intellectual property. The trademarks, symbols,
            logos, and trade names presented on this website/app are the
            property of UniBud, unless otherwise indicated.<br><br>
            UniBud.com is provided as a service to our customers and to the
            public. In developing and updating the site, we have tried to include
            complete, timely, and accurate information. However, we make no
            warranties (express or implied) about the information on this
            website/app, and we are not responsible for its use or misuse. This
            website/app is updated regularly and our menu and policies are
            subject to change without notice or obligation to users.<br><br>
            All reasonable measures have been taken to ensure the quality,
            reliability, and accuracy of the information on this website/app.
            However, we may delete, add to or amend the information on this
            website/app without notice. Further, we are not responsible for the
            content of other website/apps linked to, or referenced from, this
            website/app.<br><br>
            The services, information, software or data (collectively,
            “Information”) made available on this website/app are provided “AS
            IS”, without warranties of any kind.<br><br>
            We expressly disclaim any representations and warranties, including
            without limitation, the implied warranties of merchantability and
            fitness for a particular purpose. We shall have absolutely no liability
            in connection with the services including without limitation, any
            liability for damage to your computer hardware, data, information,
            materials and business resulting from the Information or the lack of
            information available on this website/app.<br><br>
            Specifically, we shall have no liability for any loss or injury caused, in
            whole or in part, by its actions, omissions, or negligence, or for
            contingencies beyond its control, in procuring, compiling, or
            delivering the Information herein. We shall have no liability with
            regard to any errors, omissions, or inaccuracies in the Information
            regardless of how it was caused, or delays or interruptions in
            delivery of the Information; or any decision made or action taken or
            not taken in reliance upon the Information furnished hereunder.<br><br>
            We make no warranty, representation or guarantee as to the
            content, sequence, accuracy, timeliness or completeness of the
            Information, or that the Information may be relied upon for any
            reason. We further make no warranty, representation or guaranty
            that the Information will be uninterrupted or error free or that any
            defects can be corrected.<br><br>
            Links are provided to other website/apps outside of UniBud as a
            service to users. We are not responsible for and make no
            representations about the content or use of other such
            website/apps which may be accessed through links in this web site,
            and shall not be liable for any damages or injury arising from that
            content.<br><br>
            Under no circumstances shall we be liable for any losses or damages
            whatsoever, whether in contract, tort or otherwise, from the use of,
            or reliance on, the Information, or from the use of the Internet
            generally.<br><br>
            For the purposes of this statement, “We” shall include ourselves and
            our site users, and their employees, partners, principals, agents and
            representatives, and any third-party providers or sources of
            information or data.<br><br>
            Any reproduction, distribution, display, performance, modification,
            or use of this site’s content is prohibited, unless expressly
            authorized by UniBud.
            </h5>
            <br>
            <div>
                <input
                    type="submit"
                    class="btn btn-solid"
                    value="Return"
                    @click="goBack()"
                >
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/headershop'
import Footer from '@/components/footer'

export default {
    components: {
        Header, Footer
    },
    computed: {
    },
    methods: {
        goBack() {
            this.$router.back();
        }
    }
}
</script>
